module.exports = __webpack_public_path__ + "static/media/training-center-preview.3cec01e3.png";